// extracted by mini-css-extract-plugin
export default {"field":"Field_field__tyWS9","label":"Field_label__eiRoM"};